import { render } from "./CollegeAcademics.vue?vue&type=template&id=2d33f1c0"
import script from "./CollegeAcademics.vue?vue&type=script&lang=js"
export * from "./CollegeAcademics.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__